module.exports = __webpack_public_path__ + "img/svg/energy-drink-stats.852d07442bcffc037518139fe19a8f05.svg";